export default Object.freeze({
    ACCEPT: 'ACCEPT',
    DECLINE: 'DECLINE',
    CANCEL: 'CANCEL',
    RESCHEDULE: 'RESCHEDULE',
    MAKE_UNAVAILABLE: 'MAKE_UNAVAILABLE',
    UNAVAILABLE: 'UNAVAILABLE',
    MAKE_AVAILABLE: 'CANCEL',
    DONE: 'DONE',
    NO_SHOW: 'NO_SHOW',
})
